module.exports = __webpack_public_path__ + "static/media/pin-asset-disabled.9919a81c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pins/pin-asset-disabled.svg
// module id = 2680
// module chunks = 2